import React, {
  forwardRef,
  HTMLAttributes,
  Ref,
  useEffect,
  useCallback,
} from "react";

import {
  StyledToastMessage,
  StyledToastMessageText,
  StyledCloseSmallIcon,
} from "./Styles";

export interface ToastMessageProps {
  text: string;
  type: "error" | "success" | "general" | "warning";
  onClose?: () => void;
  dismissible?: boolean;
  dropShadow?: boolean;
  timeout?: number;
}

export const ToastMessage = forwardRef(
  (
    {
      text,
      type,
      onClose,
      dismissible = false,
      dropShadow = false,
      timeout = 0,
      ...rest
    }: ToastMessageProps & HTMLAttributes<HTMLDivElement>,
    ref: Ref<HTMLDivElement> | null | undefined
  ) => {
    const handleOnClose = useCallback(() => {
      if (typeof onClose === "function") {
        onClose();
      }
    }, [onClose]);

    useEffect(() => {
      if (timeout > 0) {
        const timer = setTimeout(handleOnClose, timeout);

        return () => clearTimeout(timer);
      }
    }, [dismissible, timeout, handleOnClose]);

    return (
      <StyledToastMessage
        ref={ref}
        $type={type}
        $dropShadow={dropShadow}
        {...rest}
      >
        <StyledToastMessageText>{text}</StyledToastMessageText>
        {dismissible ? <StyledCloseSmallIcon onClick={handleOnClose} /> : null}
      </StyledToastMessage>
    );
  }
);

ToastMessage.displayName = "ToastMessage";
